import React from 'react'

import PeriodGrid from './PeriodGrid'
import usePeriodBounds from './usePeriodBounds'

/**
 * PeriodGrid for callers that declare a bound source rather than resolving the
 * strategy themselves — class components, which cannot call the hook.
 */
const BoundedPeriodGrid = (props) => {
    const { boundsSource, ...gridProps } = props

    return <PeriodGrid bounds={usePeriodBounds(boundsSource)} {...gridProps} />
}

export default BoundedPeriodGrid
